import type { ReactNode } from "react";

import { Icon } from "@/components/icons";
/** Right-side detail drawer over a list (U13) — overlay + panel + close, from
 *  the registry DeviceDrawer shell. Convention (module UI grammar):
 *  list-centric pages open a Drawer for detail; single-subject pages use a
 *  picker + inline dashboard. */
export function Drawer({ onClose, header, width = "min(560px,94vw)", children }: {
  onClose: () => void;
  /** left side of the header row (title/chips); the ✕ is added automatically */
  header: ReactNode;
  width?: string;
  children: ReactNode;
}) {
  return (
    <>
      <div onClick={onClose} style={{ position: "fixed", inset: 0, background: "rgba(15,23,32,.4)", zIndex: 40 }} />
      <aside style={{ position: "fixed", top: 0, right: 0, bottom: 0, width,
        background: "var(--surface)", borderLeft: "1px solid var(--line2)",
        boxShadow: "var(--shadow)", zIndex: 50, display: "flex", flexDirection: "column" }}>
        <div style={{ padding: "18px 22px", borderBottom: "1px solid var(--line)", display: "flex", alignItems: "center", gap: 12 }}>
          {header}
          <button className="btn ghost" style={{ marginLeft: "auto" }} onClick={onClose}><Icon name="close" /></button>
        </div>
        <div style={{ padding: "20px 22px", overflowY: "auto" }}>
          {children}
        </div>
      </aside>
    </>
  );
}
